import { FC } from 'react';
import { Redirect, Route, useHistory } from 'react-router-dom';
import { getEmployeeId } from '~/utils/sessionStorage';
import { useAppSelector } from '~/app/hooks';
import { loginCompanySelect } from '~/store/auth/selectors';

type PrivateRouteT = {
  [x: string]: any;
};

const PrivateRoute: FC<PrivateRouteT> = (props) => {
  const company = useAppSelector(loginCompanySelect);
  const isAuthenticated = Boolean(company?.id);
  const employeeId = getEmployeeId();

  const history = useHistory();

  if (!isAuthenticated) {
    return <Redirect to="/logout" />;
  }

  if (!employeeId && history.location.pathname !== '/employeeLogin') {
    return <Redirect to="/employeeLogin" />;
  }

  return <Route {...props} />;
};

export default PrivateRoute;
